import { createAction, props } from '@ngrx/store';
import {
  IndividualReportTemplateModel,
  IndividualTemplateConfigModel,
} from '../model/individual-report-template.model';

export const IndTemplateBuilderActions = {
  loadTemplate: createAction('[IndTemplateBuilder] Load Template', props<{ templateOid: number }>()),
  loadTemplateSuccess: createAction(
    '[IndTemplateBuilder] Load Template Success',
    props<{ template: IndividualReportTemplateModel | null }>(),
  ),
  loadTemplateFailure: createAction('[IndTemplateBuilder] Load Template Failure', props<{ error: string }>()),

  updateTemplateInformation: createAction(
    '[IndTemplateBuilder] Update Template Information',
    props<{ templateName: string; templateDescription: string }>(),
  ),
  // The reducer shallow-merges top-level config keys, so pages must send COMPLETE nested objects.
  // This is safe while each top-level config key is owned by exactly one page — revisit with
  // granular per-slice actions if a nested object ever gets edited from more than one page.
  updateTemplateConfig: createAction(
    '[IndTemplateBuilder] Update Template Config',
    props<{ templateConfig: Partial<IndividualTemplateConfigModel> }>(),
  ),

  saveTemplate: createAction(
    '[IndTemplateBuilder] Save Template',
    props<{ templateOid: number; template: IndividualReportTemplateModel; redirectToList?: boolean }>(),
  ),
  saveTemplateSuccess: createAction(
    '[IndTemplateBuilder] Save Template Success',
    props<{ redirectToList?: boolean }>(),
  ),
  saveTemplateFailure: createAction('[IndTemplateBuilder] Save Template Failure', props<{ error: string }>()),

  resetStore: createAction('[IndTemplateBuilder] Reset Store'),
};
